module.exports = __webpack_public_path__ + "img/dummy-img-1920x900.d8138250.jpg";